import { render, staticRenderFns } from "./JudgeActionTypeView.vue?vue&type=template&id=9a3b9724&scoped=true&"
import script from "./JudgeActionTypeView.vue?vue&type=script&setup=true&lang=js&"
export * from "./JudgeActionTypeView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./JudgeActionTypeView.vue?vue&type=style&index=0&id=9a3b9724&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3b9724",
  null
  
)

export default component.exports